import { Box } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const InformationContainer = styled(Box)`
  display: grid;
  grid-template-columns: minmax(300px, 1fr) minmax(300px, 1fr);

  @media (max-width: 650px) {
    grid-template-columns: 1fr;
  }
`
